var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$prefixClass.card + '-stroke', 'summary-box']},[_c('h6',{staticClass:"summary-box__title m-b-5"},[_vm._v(_vm._s(_vm.title))]),_c('h4',{staticClass:"summary-box__total primary-color m-0"},[_vm._v(_vm._s(_vm.total ? (_vm.isFormatSize ? _vm.formatSize(_vm.total) : _vm.total) : '--'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }